(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DefPromise", [], factory);
	else if(typeof exports === 'object')
		exports["DefPromise"] = factory();
	else
		root["DefPromise"] = factory();
})((typeof self !== 'undefined' ? self : (typeof global !== 'undefined' ? global : this)), function() {
return 